import {getJson, postJson} from '@/util/ajaxUtils';
import {get} from '@/page/admin/SettingsPage/utils';

export function searchUsers(type) {
    return getJson(`/cons/list/${type}`, {});
}

export function searchContact(extId, type, fromType) {
    return getJson(`/cons/search/contact/${extId}/${type}/${fromType}`, {});
}

export function searchPage(searchParam) {
    return postJson('/cons/searchpage', {data: searchParam});
}

export function test() {
    return getJson('/cons/test', {});
}

export function getCard(userId) {
    return getJson(`/cons/card/${userId}`, {});
}

export function searchPageByIntercept(sensitiveHitId, size) {
    return getJson(`cons/intercept/page/${sensitiveHitId}/${size}`, {});
}

export function searchConsPageByIntercept(data) {
    return postJson('cons/intercept/page', {data: data});
}
